"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Avatar = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_textfit_1 = require("react-textfit");
var component_library_1 = require("@kaizen/component-library");
var user_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/user.icon.svg"));
var Avatar_module_scss_1 = __importDefault(require("./Avatar.module.scss"));
var getInitials = function (fullName, max2Characters) {
    if (max2Characters === void 0) { max2Characters = false; }
    return fullName == null
        ? ""
        : fullName
            .split(/\s/)
            .reduce(function (acc, name) { return "".concat(acc).concat(name.slice(0, 1)); }, "")
            .toUpperCase()
            .substring(0, max2Characters ? 2 : 8);
};
var getMaxFontSizePixels = function (size) {
    if (size === "small")
        return 8;
    if (size === "medium")
        return 16;
    if (size === "xlarge" || size === "xxlarge")
        return 34;
    return 22;
};
var fallbackIcon = function (fullName) { return (react_1["default"].createElement("span", { className: Avatar_module_scss_1["default"].fallbackIcon },
    react_1["default"].createElement(component_library_1.Icon, { inheritSize: true, role: fullName ? "img" : "presentation", title: fullName, icon: user_icon_svg_1["default"] }))); };
var renderInitials = function (fullName, size, disableInitials) {
    if (fullName === void 0) { fullName = ""; }
    if (disableInitials === void 0) { disableInitials = false; }
    var initials = getInitials(fullName);
    var isLongName = initials.length > 2 && size !== "small";
    var renderFallback = disableInitials || initials === "";
    return renderFallback ? (fallbackIcon(fullName)) : (react_1["default"].createElement("abbr", { className: (0, classnames_1["default"])(Avatar_module_scss_1["default"].initials, isLongName && Avatar_module_scss_1["default"].longName), title: fullName || "" }, isLongName ? (
    // Only called if 3 or more initials, fits text width for long names
    react_1["default"].createElement(react_textfit_1.Textfit, { mode: "single", max: getMaxFontSizePixels(size) }, initials)) : (getInitials(fullName, size === "small"))));
};
/**
 * {@link https://cultureamp.design/components/avatar/ Guidance} |
 * {@link https://cultureamp.design/storybook/?path=/docs/components-avatar-avatar--default-story Storybook}
 */
var Avatar = function (_a) {
    var fullName = _a.fullName, _b = _a.size, size = _b === void 0 ? "medium" : _b, avatarSrc = _a.avatarSrc, _c = _a.disableInitials, disableInitials = _c === void 0 ? false : _c, _d = _a.isCompany, isCompany = _d === void 0 ? false : _d, _e = _a.isCurrentUser, isCurrentUser = _e === void 0 ? true : _e, classNameOverride = _a.classNameOverride, restProps = __rest(_a, ["fullName", "size", "avatarSrc", "disableInitials", "isCompany", "isCurrentUser", "classNameOverride"]);
    var _f = (0, react_1.useState)(avatarSrc ? "loading" : "none"), avatarState = _f[0], setAvatarState = _f[1];
    var image = (0, react_1.useRef)(null);
    var renderInitialAvatar = !isCompany && (avatarState === "none" || avatarState === "error");
    (0, react_1.useEffect)(function () {
        setAvatarState(avatarSrc ? "loading" : "none");
    }, [avatarSrc]);
    var onImageFailure = function () { return setAvatarState("error"); };
    var onImageSuccess = function () { return setAvatarState("success"); };
    // if the image is cached onLoad may not trigger: https://stackoverflow.com/a/59809184
    (0, react_1.useEffect)(function () {
        var _a;
        if ((_a = image === null || image === void 0 ? void 0 : image.current) === null || _a === void 0 ? void 0 : _a.complete)
            onImageSuccess();
    }, [image]);
    var isNoneOrError = avatarState === "none" || avatarState === "error";
    var isPersonal = isNoneOrError && isCurrentUser;
    var isOtherUser = isNoneOrError && !isCurrentUser;
    return (react_1["default"].createElement("span", __assign({ className: (0, classnames_1["default"])(Avatar_module_scss_1["default"].wrapper, Avatar_module_scss_1["default"][size], classNameOverride, isCompany && Avatar_module_scss_1["default"].company, isPersonal && Avatar_module_scss_1["default"].personal, isOtherUser && Avatar_module_scss_1["default"].otherUser, (avatarState === "loading" || avatarState === "error") && Avatar_module_scss_1["default"].loading) }, restProps),
        avatarState !== "none" && (react_1["default"].createElement("img", { ref: image, className: (0, classnames_1["default"])(Avatar_module_scss_1["default"].avatarImage, isCompany && Avatar_module_scss_1["default"].companyAvatarImage), src: avatarSrc, onError: onImageFailure, onLoad: onImageSuccess, alt: fullName || "" })),
        renderInitialAvatar && renderInitials(fullName, size, disableInitials)));
};
exports.Avatar = Avatar;
//# sourceMappingURL=Avatar.js.map